import React, { useMemo, useCallback } from 'react';
import { localize } from '@guuru/translation-common';
import { Space } from 'antd';

interface OptionProps {
  id: string;
  name: string | Record<string, string | undefined>;
  children?: React.ReactNode;
  // eslint-disable-next-line no-unused-vars
  onClick: (id: string, label: string) => void;
  locale?: string;
  className?: string;
  icon?: React.ReactNode,
}

const Option = function ({
  id,
  name,
  onClick,
  locale = 'en',
  children = undefined,
  className = '',
  icon = undefined,
}: OptionProps) {
  const label = useMemo(() => localize(name, locale), [name, locale]);

  const handleSelection = useCallback(() => (
    onClick(id, label ?? '')
  ), [onClick, id, label]);

  return (
    <div
      className={className}
      onClick={handleSelection}
      onKeyPress={handleSelection}
      role="menuitem"
      tabIndex={0}
    >
      <Space>
        {children ?? label}
        {icon ?? icon}
      </Space>

    </div>
  );
};

export default Option;
